"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var vg_dash_1 = require("./vg-dash/vg-dash");
var vg_hls_1 = require("./vg-hls/vg-hls");
var VgStreamingModule = (function () {
    function VgStreamingModule() {
    }
    VgStreamingModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [
                        vg_dash_1.VgDASH, vg_hls_1.VgHLS
                    ],
                    exports: [
                        vg_dash_1.VgDASH, vg_hls_1.VgHLS
                    ]
                },] },
    ];
    return VgStreamingModule;
}());
exports.VgStreamingModule = VgStreamingModule;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyZWFtaW5nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3N0cmVhbWluZy9zdHJlYW1pbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxzQ0FBOEM7QUFDOUMsMENBQStDO0FBQy9DLDZDQUEyQztBQUMzQywwQ0FBd0M7Ozs7O2dCQVF2QyxlQUFRLFNBQUM7b0JBQ04sT0FBTyxFQUFFLENBQUUscUJBQVksQ0FBRTtvQkFDekIsWUFBWSxFQUFFO3dCQUNWLGdCQUFNLEVBQUUsY0FBSztxQkFDaEI7b0JBQ0QsT0FBTyxFQUFFO3dCQUNMLGdCQUFNLEVBQUUsY0FBSztxQkFDaEI7aUJBQ0o7OzRCQW5CRDs7QUFvQmEsOENBQWlCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTmdNb2R1bGUgfSAgICAgIGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuaW1wb3J0IHsgQ29tbW9uTW9kdWxlIH0gZnJvbSAnQGFuZ3VsYXIvY29tbW9uJztcbmltcG9ydCB7IFZnREFTSCB9IGZyb20gXCIuL3ZnLWRhc2gvdmctZGFzaFwiO1xuaW1wb3J0IHsgVmdITFMgfSBmcm9tIFwiLi92Zy1obHMvdmctaGxzXCI7XG5cbmV4cG9ydCBpbnRlcmZhY2UgSURSTUxpY2Vuc2VTZXJ2ZXIge1xuICAgIFtpbmRleDogc3RyaW5nXToge1xuICAgICAgICBzZXJ2ZXJVUkw6IHN0cmluZztcbiAgICB9XG59XG5cbkBOZ01vZHVsZSh7XG4gICAgaW1wb3J0czogWyBDb21tb25Nb2R1bGUgXSxcbiAgICBkZWNsYXJhdGlvbnM6IFtcbiAgICAgICAgVmdEQVNILCBWZ0hMU1xuICAgIF0sXG4gICAgZXhwb3J0czogW1xuICAgICAgICBWZ0RBU0gsIFZnSExTXG4gICAgXVxufSlcbmV4cG9ydCBjbGFzcyBWZ1N0cmVhbWluZ01vZHVsZSB7fVxuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/videogular2/src/streaming/streaming.js
// module id = 687
// module chunks = 1